






























import { DiscountParams } from '@/store/interfaces/discount';
import { tCashbackParams } from '@/store/interfaces/cashback';
import Vue from 'vue';

export default Vue.extend({
  name: 'DicountCap',
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams) {
        this.$emit('update:model', value);
      },
    },
  },
  data: () => ({
    caps: [
      {
        name: 'Todos',
        id: 'all',
      },
      {
        name: 'Monto máximo',
        id: 'ceiling',
      }
    ],
  }),
  methods: {
    isCapCeiling(): boolean {
      return this.model.cap === 'ceiling';
    },
  },
});
